const CurrencySymbol = {
  USD: "$",
  AUD: "A$",
  GBP: "￡",
  CAD: "C$",
  EUR: "€"
};

export default CurrencySymbol;
